// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useCallback, useRef, useState } from 'react';
import { useOverlayTrigger, useOverlayPosition } from '@react-aria/overlays';
import { PopoverContext, containerPadding } from './context';
const PopoverTriggerBase = ({ children, popoverProps = { containerPadding }, }) => {
    return (React.createElement(PopoverContext.Provider, { value: { ...popoverProps } }, children));
};
export const PopoverTrigger = ({ autoFocus = false, children, placement = 'bottom', tip = false, targetRef, onClose = () => { }, }) => {
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    const overlayRef = useRef(null);
    const { triggerProps, overlayProps } = useOverlayTrigger({ type: 'dialog' }, {
        isOpen: open,
        open: () => setOpen(true),
        close: () => setOpen(false),
        toggle: () => setOpen(!open),
    }, triggerRef);
    const { overlayProps: positionProps, placement: overlayPlacement, arrowProps: tipProps, } = useOverlayPosition({
        targetRef: targetRef || triggerRef,
        overlayRef,
        placement,
        offset: 0,
        isOpen: open,
        containerPadding,
    });
    const handleClick = useCallback(() => {
        setOpen(!open);
        if (open) {
            onClose();
        }
    }, [onClose, open]);
    const handleClose = useCallback(() => {
        onClose();
        setOpen(false);
    }, [onClose]);
    const triggerPropsWithRef = {
        ...triggerProps,
        onClick: handleClick,
        ref: triggerRef,
    };
    return (React.createElement(PopoverTriggerBase, { popoverProps: {
            autoFocus,
            containerPadding,
            open,
            onClose: handleClose,
            ...overlayProps,
            ...positionProps,
            tipProps,
            tip,
            placement: overlayPlacement,
            ref: overlayRef,
            triggerRef,
        } }, children(triggerPropsWithRef, handleClose)));
};
//# sourceMappingURL=PopoverTrigger.js.map